export default __webpack_public_path__ + "static/media/white-filled-thumb.f300b01e.svg";